import { partial } from '../../../util/translation/translation';

const validate = (values) => {
  const p = partial('validateErrors');
  const errors = {};
  if (!values.dateFrom) {
    errors.dateFrom = p('dateFromFieldCantBeEmpty');
  }
  if (!values.dateTo) {
    errors.dateTo = p('dateToFieldCantBeEmpty');
  }
  return errors;
};
export default validate;
